<template>
  <div class="water-mark" :class="isFullFlag ? 'wrap-fullScreen' : ''">
    <div ref="barrageTop" class="barrage-item barrage-item-top" :style="{ transform: 'translateX(9000px)' }">
      {{ userInfo && userInfo.hospitalName }}-{{ userInfo && userInfo.realName }}正在学习
    </div>
    <div ref="barrageBottom" class="barrage-item barrage-item-bottom" :style="{ transform: 'translateX(9000px)' }">
      {{ userInfo && userInfo.hospitalName }}-{{ userInfo && userInfo.realName }}正在学习
    </div>
  </div>
</template>

<script>
// import { mapState } from 'vuex'
export default {
  props: ['isFullScreen'],
  data() {
    return {
      showTop: true,
      isRotated: false, // 屏幕自动旋转
      isFullFlag: false,
      // barrageTimerBottom: 0,
      // barrageTimerTop: 0,
      bTop: 0,
      bBot: 0,
      pageWidthNow: 0
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    }
  },
  watch: {
    $route() {
      if (this.barrageTimerTop) {
        clearInterval(this.barrageTimerTop)
      }
      if (this.barrageTimerBottom) {
        clearInterval(this.barrageTimerBottom)
      }
      this.init()
    },
    isFullScreen() {
      if (this.barrageTimerTop) {
        clearInterval(this.barrageTimerTop)
      }
      if (this.barrageTimerBottom) {
        clearInterval(this.barrageTimerBottom)
      }
      this.init()
    }
  },
  mounted() {
    this.bTop = this.$refs.barrageTop
    this.bBot = this.$refs.barrageBottom
    this.isRotateScreen()
    window.addEventListener('onorientationchange' in window ? 'orientationchange' : 'resize', this.onRotate, false)
    this.init()
    // window.addEventListener('resize', this.renderResize, false)
  },
  beforeUnmount() {
    window.removeEventListener('onorientationchange', this.onRotate, false)
    // window.removeEventListener('resize', this.renderResize, false)
  },
  unmounted() {
    this.clearTimer()
  },
  methods: {
    init() {
      this.$nextTick(() => {
        let barrageTop = this.$refs.barrageTop
        let barrageBottom = this.$refs.barrageBottom
        let pageWidth = this.isFullScreen || this.isRotated || this.isFullFlag ? document.documentElement.clientHeight || document.body.clientHeight : document.documentElement.clientWidth || document.body.clientWidth
        let barrageBotWidthNow = this.isFullScreen || this.isRotated ? this.bBot.clientWidth * 2 : this.bBot.clientWidth
        let barrageTopWidthNow = this.isFullScreen || this.isRotated ? this.bTop.clientWidth * 2 : this.bBot.clientWidth
        this.pageWidthNow = pageWidth
        barrageTop.style = `transform: translateX(${pageWidth + barrageTopWidthNow}px)`
        barrageBottom.style = `transform: translateX(${pageWidth + barrageBotWidthNow}px)`
        this.topMove(pageWidth)
      })
    },
    topMove(pageWidth) {
      let barrageTop = this.$refs.barrageTop
      let barrageLeft = this.pageWidthNow
      if (this.barrageTimerTop) {
        clearInterval(this.barrageTimerTop)
      }
      this.barrageTimerTop = setInterval(() => {
        barrageLeft--
        if (barrageLeft - -barrageTop.offsetWidth === 80) {
          this.bottomMove(pageWidth)
        }
        if (barrageLeft <= -barrageTop.offsetWidth) {
          clearInterval(this.barrageTimerTop)
        }
        barrageTop.style = `transform: translateX(${barrageLeft}px)`
      }, 16)
    },
    bottomMove(pageWidth) {
      let barrageBottom = this.$refs.barrageBottom
      let barrageLeft = this.pageWidthNow
      if (this.barrageTimerBottom) {
        clearInterval(this.barrageTimerBottom)
      }
      this.barrageTimerBottom = setInterval(() => {
        barrageLeft--
        if (barrageLeft - -barrageBottom.offsetWidth === 50) {
          this.topMove(pageWidth)
        }
        if (barrageLeft <= -(barrageBottom.offsetWidth + 80)) {
          clearInterval(this.barrageTimerBottom)
        }
        barrageBottom.style = `transform: translateX(${barrageLeft}px)`
      }, 16)
    },
    clearTimer() {
      if (this.barrageTimerTop) {
        clearInterval(this.barrageTimerTop)
      }
      if (this.barrageTimerBottom) {
        clearInterval(this.barrageTimerBottom)
      }
    },
    renderResize() {
      this.clearTimer()
      this.init()
    },
    onRotate() {
      this.isRotated = window.orientation === 90 || window.orientation === -90
      this.isFullFlag = this.isRotated
      this.renderResize()
    },
    isRotateScreen() {
      let width = document.documentElement.clientWidth || document.body.clientWidth
      let height = document.documentElement.clientHeight || document.body.clientHeight
      this.isFullFlag = width > height
    }
  }
}
</script>

<style lang="less" scoped>
.water-mark {
  .barrage-item {
    position: fixed;
    z-index: 9990;
    white-space: nowrap;
    padding: 6px 10px;
    font-size: 10px;
    border-radius: 13px;
    background: rgba(1, 1, 1, 0.3);
    transform: rotate(90deg);
    color: #fff;
    &.barrage-item-top {
      top: 70px;
    }
    &.barrage-item-bottom {
      top: 130px;
    }
  }
  .wrap-fullScreen {
    .barrage-item {
      font-size: 6px;
      &.barrage-item-top {
        top: 50px;
      }
      &.barrage-item-bottom {
        top: 70px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/course/components/WaterMark.vue